import keyMirror from 'keymirror';

export default keyMirror({
	CLEAR_ERROR: null,
	SHOW_ERROR: null
});


// WEBPACK FOOTER //
// ./src/constants/ErrorConstants.js